module.exports = __webpack_public_path__ + "6ceed270d9bc423892bca8d02fbac700.png";